import { Link } from 'react-router-dom';
import { Logo } from '@/components/brand/Logo';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/app/AuthProvider';
import { ROLE_LABELS } from '@/lib/permissions';

/**
 * Choose the safest "back to" target for the given role. The default
 * /dashboard works for every internal role today but is forbidden to
 * `external_lender`, who would otherwise end up bouncing back here in
 * a loop — send them to their loan ledger instead. Keep this list
 * narrow: only roles that DON'T have dashboard access need to be
 * mapped, every other role falls through to /dashboard.
 */
function safeLandingFor(role: string | null | undefined): string {
  if (role === 'external_lender') return '/financials/loans/family';
  return '/dashboard';
}

export function ForbiddenPage() {
  const { profile } = useAuth();
  const target = safeLandingFor(profile?.role);
  const targetLabel =
    target === '/dashboard' ? 'Back to dashboard' : 'Back to your loan ledger';
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background p-6">
      <div className="w-full max-w-md space-y-6 text-center">
        <Logo variant="symbol" tone="humus" className="mx-auto h-12 w-12" />
        <div className="space-y-2">
          <h1 className="text-2xl font-medium tracking-headline">Forbidden</h1>
          <p className="text-sm text-muted-foreground">
            Your role ({profile ? ROLE_LABELS[profile.role] : 'unknown'}) doesn't
            have access to that area. Ask a Super Admin if you think this is wrong.
          </p>
        </div>
        <Button asChild>
          <Link to={target}>{targetLabel}</Link>
        </Button>
      </div>
    </div>
  );
}
